<div class="current-medical-center">
  <div class="icon">
    <mat-icon svgIcon="hospital"></mat-icon>
  </div>

  <div class="info-medical-center">
    <p class="text-medical-center">
      Centro médico {{ getCurrentMedicalCenter()?.nombre || "" }}
    </p>
    <button
      mat-stroked-button
      class="btn-change-center"
      (click)="goToMedicalCenters()"
    >
      Cambiar centro médico
      <mat-icon svgIcon="swap-horizontal"></mat-icon>
    </button>
  </div>
</div>
